var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuspension(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.226,
    height: 73.194,
    viewBox: "0 0 73.226 73.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "noun-suspension-3956189",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2852",
    "data-name": "Path 2852",
    d: "M17.284,56.52a5.935,5.935,0,1,1,4.2-1.736A5.935,5.935,0,0,1,17.284,56.52Zm0-8.9a2.967,2.967,0,1,0,2.092.875A2.967,2.967,0,0,0,17.284,47.618Z",
    transform: "translate(-5.337 10.694)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2853",
    "data-name": "Path 2853",
    d: "M19.245,64.39a11.87,11.87,0,1,1,3.932-23.042,1.481,1.481,0,1,1-.994,2.789,8.784,8.784,0,0,0-9.273,2.092,8.935,8.935,0,1,0,14.719,3.309,1.484,1.484,0,1,1,2.789-.95A11.87,11.87,0,0,1,19.245,64.434Z",
    transform: "translate(-7.299 8.759)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2854",
    "data-name": "Path 2854",
    d: "M36.329,21.615a1.491,1.491,0,0,1-1.039-2.537l4.229-4.2a1.484,1.484,0,1,1,2.092,2.092l-4.229,4.273A1.484,1.484,0,0,1,36.329,21.615Z",
    transform: "translate(6.033 -3.958)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2855",
    "data-name": "Path 2855",
    d: "M25.027,32.908a1.484,1.484,0,0,1-1.053-2.537l4.2-4.229a1.49,1.49,0,1,1,2.107,2.107l-4.2,4.2a1.484,1.484,0,0,1-1.053.46Z",
    transform: "translate(0.555 1.531)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2856",
    "data-name": "Path 2856",
    d: "M23.563,42.682a1.484,1.484,0,0,1-1.039-.43l-4.2-4.2a1.452,1.452,0,0,1,0-2.092l4.184-4.14A1.485,1.485,0,1,1,24.6,33.928l-3.131,3.146,3.146,3.146a1.42,1.42,0,0,1-1.053,2.463Z",
    transform: "translate(-2.18 4.28)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2857",
    "data-name": "Path 2857",
    d: "M30.684,27.208a1.476,1.476,0,0,1-1.053-2.522l4.2-4.2a1.484,1.484,0,0,1,2.092,2.092l-4.184,4.2A1.484,1.484,0,0,1,30.684,27.208Z",
    transform: "translate(3.295 -1.167)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2858",
    "data-name": "Path 2858",
    d: "M46.229,31.542a1.491,1.491,0,0,1-1.039-2.537l4.2-4.2a1.484,1.484,0,1,1,2.092,2.062l-4.2,4.2A1.484,1.484,0,0,1,46.229,31.542Z",
    transform: "translate(10.822 0.804)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2859",
    "data-name": "Path 2859",
    d: "M34.927,42.8a1.484,1.484,0,0,1-1.053-2.537l4.2-4.2a1.5,1.5,0,1,1,2.137,2.107l-4.2,4.2A1.484,1.484,0,0,1,34.927,42.8Z",
    transform: "translate(5.344 6.326)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2860",
    "data-name": "Path 2860",
    d: "M30.657,48.48a1.484,1.484,0,0,1-1.039-.445l-4.2-4.184a1.484,1.484,0,1,1,2.092-2.092L30.657,44.9l3.16-3.146a1.484,1.484,0,1,1,2.092,2.092l-4.2,4.2A1.484,1.484,0,0,1,30.657,48.48Z",
    transform: "translate(1.216 9.045)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2861",
    "data-name": "Path 2861",
    d: "M40.584,37.108a1.476,1.476,0,0,1-1.053-2.522l4.2-4.2a1.484,1.484,0,0,1,2.092,2.092l-4.2,4.2A1.484,1.484,0,0,1,40.584,37.108Z",
    transform: "translate(8.084 3.622)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2862",
    "data-name": "Path 2862",
    d: "M56.685,31.3a1.484,1.484,0,0,1-1.053-2.537l5.252-5.238-12.6-12.6-5.238,5.252a1.49,1.49,0,0,1-2.107-2.107l6.306-6.291a1.484,1.484,0,0,1,2.092,0L64.029,22.47a1.484,1.484,0,0,1,0,2.092l-6.291,6.306A1.484,1.484,0,0,1,56.685,31.3Z",
    transform: "translate(8.765 -7.349)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2863",
    "data-name": "Path 2863",
    d: "M18.182,45.991a1.484,1.484,0,0,1-1.039-2.537l5.935-5.935a1.484,1.484,0,1,1,2.092,2.092l-5.935,5.935A1.484,1.484,0,0,1,18.182,45.991Z",
    transform: "translate(-2.749 6.994)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2864",
    "data-name": "Path 2864",
    d: "M22.424,50.2a1.476,1.476,0,0,1-1.053-2.522l5.935-5.935a1.485,1.485,0,1,1,2.122,2.077l-5.935,5.935a1.484,1.484,0,0,1-1.068.445Z",
    transform: "translate(-0.7 9.074)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2865",
    "data-name": "Path 2865",
    d: "M42.013,54.314a4.451,4.451,0,0,1-3.146-1.306L19.979,34.121a4.451,4.451,0,0,1,6.291-6.291L45.158,46.717a4.451,4.451,0,0,1-3.146,7.6ZM23.125,29.491a1.484,1.484,0,0,0-1.053,2.537L40.959,50.916h0a1.485,1.485,0,0,0,2.107-2.092l-18.888-18.9A1.484,1.484,0,0,0,23.125,29.491Z",
    transform: "translate(-1.742 1.98)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2866",
    "data-name": "Path 2866",
    d: "M47.708,48.683a4.451,4.451,0,0,1-3.116-1.306h0L25.674,28.46a4.451,4.451,0,0,1,0-6.291,4.57,4.57,0,0,1,6.291,0L50.853,41.087a4.451,4.451,0,0,1-3.146,7.6Zm-1.053-3.4a1.485,1.485,0,1,0,2.092-2.107L29.873,24.306A1.485,1.485,0,0,0,27.766,26.4Z",
    transform: "translate(0.961 -0.787)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2867",
    "data-name": "Path 2867",
    d: "M53.355,43.058a4.451,4.451,0,0,1-3.146-1.291h0L31.337,22.835a4.451,4.451,0,0,1,0-6.306,4.57,4.57,0,0,1,6.291,0L56.516,35.417a4.451,4.451,0,0,1-3.16,7.641Zm-1.039-3.4a1.479,1.479,0,0,0,2.092-2.092L35.521,18.636a1.479,1.479,0,0,0-2.092,2.092L52.317,39.616Z",
    transform: "translate(3.696 -3.516)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2868",
    "data-name": "Path 2868",
    d: "M59.055,37.417a4.451,4.451,0,0,1-3.146-1.306L37.022,17.223a4.451,4.451,0,1,1,6.291-6.291L62.2,29.82a4.451,4.451,0,0,1-3.146,7.6ZM40.167,12.594a1.484,1.484,0,0,0-1.009,2.537L58,33.974h0a1.479,1.479,0,0,0,2.092-2.092L41.221,13.024A1.484,1.484,0,0,0,40.167,12.594Z",
    transform: "translate(6.394 -6.301)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspension);
export default __webpack_public_path__ + "static/media/suspension.303fb2f78ce0c41c3bd92c28af3b16f3.svg";
export { ForwardRef as ReactComponent };